import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { serialiseProject } from '@bw/document';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { useEditor } from './state/store.js';
import { downloadBytes } from './editor/exporting.js';
import './styles.css';

/** A crash must not take the user's work with it. */
function rescueProject(): void {
  try {
    const project = useEditor.getState().project;
    const name = project.name.trim() === '' ? 'Recovered' : project.name.trim();
    downloadBytes(`${name}.bwall`, new TextEncoder().encode(serialiseProject(project)), 'application/json');
  } catch {
    // Nothing left to rescue.
  }
}

const container = document.getElementById('root');
if (container === null) throw new Error('Missing #root');
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary onRecover={rescueProject}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
